export const ORDER_CREATE = 'ORDER_CREATE'
export const ORDER_UPDATE = 'ORDER_UPDATE'
export const ORDER_CANCEL = 'ORDER_CANCEL'
